import get from 'lodash/get';
import { Settings } from '../types/settings';

const getOffsets = ({ width, height, isMobile, isFullscreen, settings, dpr }) => {
  const isHorizontal = width > height && isMobile;
  const offsetX = width / 6;

  if (isHorizontal) {
    return {
      offsetX,
      offsetY: 50,
    };
  }

  const minYPadding = isFullscreen ? 210 : 190;
  const minOffsetY = settings && settings.previewMode ? 0 : minYPadding * dpr;

  let offsetY = height / 4;

  offsetY = Math.max(offsetY, minOffsetY) + 124;

  return {
    offsetX,
    offsetY,
  };
};

const getWidgetParams = ({
  width,
  height,
  dpr,
  isFullscreen = false,
  isMobile,
  settings,
  coords: { minX, minY, maxX, maxY },
  prevParams,
}: {
  width: number;
  height: number;
  dpr: number;
  isFullscreen?: boolean;
  isMobile: boolean;
  settings: Settings;
  coords: { minX: number; minY: number; maxX: number; maxY: number };
  prevParams?: {
    matrix: DOMMatrix;
  };
}) => {
  const schemeWidth = maxX - minX;
  const schemeHeight = maxY - minY;
  const scaleY = +(height / schemeHeight).toFixed(5);
  const scaleX = +(width / schemeWidth).toFixed(5);
  let scale = 1;
  let isStadium = false;

  if (scaleX < 1 || scaleY < 1) {
    scale = Math.min(scaleX, scaleY);
  }

  let playgroundWidth = schemeWidth * scale;
  let playgroundHeight = schemeHeight * scale;

  const { offsetX, offsetY } = getOffsets({ width, height, isMobile, isFullscreen, settings, dpr });

  const diffYOffset = height - playgroundHeight;
  const diffXOffset = width - playgroundWidth;

  let scaleFromOffsetX;
  let scaleFromOffsetY;

  if (diffXOffset < offsetX) {
    scaleFromOffsetX = +((width - offsetX) / schemeWidth).toFixed(5);
  }

  if (diffYOffset < offsetY) {
    scaleFromOffsetY = +((height - offsetY) / schemeHeight).toFixed(5);
  }

  if (scaleFromOffsetX || scaleFromOffsetY) {
    scale = scaleFromOffsetX || scaleFromOffsetY;
  }

  if (scaleFromOffsetX && scaleFromOffsetY) {
    scale = Math.min(scaleFromOffsetX, scaleFromOffsetY);
  }

  playgroundHeight = schemeHeight * scale;
  playgroundWidth = schemeWidth * scale;

  let zoomArray = [1, 2];

  if (scale < 0.3 && (schemeWidth > 4000 || schemeHeight > 4000)) {
    isStadium = true;
    zoomArray = [0.3, 1, 2];
  }

  const nextZooms = zoomArray.map((zoom) => zoom * dpr);
  const zoomRange = scale < dpr ? [scale, ...nextZooms] : [...nextZooms];

  const startX = width / 2 - playgroundWidth / 2;
  const startY = height / 2 - playgroundHeight / 2;

  let tx;
  let ty;
  let oldZoom;
  if (prevParams) {
    const {
      matrix: { a, f, e },
    } = prevParams;

    oldZoom = Number(a.toFixed(5));
    tx = e;
    ty = f;
  }

  return {
    zoomRange,
    oldZoom,
    playgroundHeight,
    playgroundWidth,
    startX,
    startY,
    tx,
    ty,
    isStadium,
  };
};

const widgetNavIsHidden = (props) => {
  return !props.isFullscreen;
};

const transformWidgetSchemeData = ({ settings, schemeData }) => {
  if (settings.hostname && get(schemeData, 'meta.hall_layout.meta.bg')) {
    schemeData.meta.hall_layout.meta.bg = schemeData.meta.hall_layout.meta.bg.replace(
      'https://cdn.pbilet.com/',
      'https://api.selcdn.ru/v1/SEL_85399/cdn/',
    );
  }

  return schemeData;
};

export { getWidgetParams, widgetNavIsHidden, transformWidgetSchemeData };
